import * as types from "../redux/types";
import backend from "../api/api";
import { store } from "../redux/store";
import { message } from "antd";

// let Protected = store.getState().auth.Protected ? true : "";

const getConfig = () => {
  const token = store.getState().auth.token;

  const config = {
    headers: {
      Authorization: `Token ${token}`,
    },
  };

  return config;
};

export const getSalesReportGraph = async (
  start,
  end,
  invoice_number,
  delivery_date,
  Payment_method,
  status,
  contact,
  location,
  account
) => {
  try {
    const response = await backend.get(
      `api/order/invoices/?is_public=${store.getState().auth.Protected ? true : ""
      }&start=${start}&end=${end}&invoice_number=${invoice_number}&delivery_date=${delivery_date}&Payment_method=${Payment_method}&status=${status}&contact=${contact}&location=${location}&account=${account}`,
      getConfig()
    );

    if (response.status === 200) {
      return response.data;
    }
  } catch (error) {
    console.log(error);
    return [];
  }
};

export const getSalesReport =
  (
    start,
    end,
    invoice_number,
    delivery_date,
    Payment_method,
    status,
    contact,
    location,
    account
  ) =>
    async (dispatch) => {
      try {
        const response = await backend.get(
          `api/order/invoices/?is_public=${store.getState().auth.Protected ? true : ""
          }&start=${start}&end=${end}&invoice_number=${invoice_number}&delivery_date=${delivery_date}&Payment_method=${Payment_method}&status=${status}&contact=${contact}&location=${location}&account=${account}`,
          getConfig()
        );
        if (response.status === 200) {
          return response.data;
        }
      } catch (error) {
        console.log(error);
      }
    };

export const getDailyCollection =
  (start, end, location) => async (dispatch) => {
    try {
      const response = await backend.get(
        `api/order/invoicepayments/daily-collection/?invoice__is_public=${
          store.getState().auth.Protected ? true : ""
        }&start=${start}&end=${end}&invoice__location__id=${location || ""}`,
        getConfig()
      );
      if (response.status === 200) {
        return response.data;
      }
    } catch (error) {
      console.log(error);
    }
  };
export const getSalesReportP =
  (
    start,
    end,
    keyward,
    invoice_number,
    delivery_date,
    Payment_method,
    status,
    contact,
    location,
    account,
    pageno = 1,
    page_size = 100,
    location_name_in = "",
    Sales_person = ""
  ) =>
    async (dispatch) => {
      try {
        let queryParams = `is_public=${store.getState().auth.Protected ? true : ""}&page=${pageno}&page_size=${page_size}`;
        if (keyward) queryParams += `&keyward=${keyward}`;
        if (start) queryParams += `&start=${start}`;
        if (end) queryParams += `&end=${end}`;
        if (invoice_number) queryParams += `&invoice_number=${invoice_number}`;
        if (delivery_date) queryParams += `&delivery_date=${delivery_date}`;
        if (Payment_method) queryParams += `&Payment_method=${Payment_method}`;
        if (status) queryParams += `&status=${status}`;
        if (contact) queryParams += `&contact=${contact}`;
        if (location) queryParams += `&location=${location}`;
        if (account) queryParams += `&account=${account}`;
        if (location_name_in) queryParams += `&location_name_in=${location_name_in}`;
        if (Sales_person) queryParams += `&Sales_person=${Sales_person}`;

        const response = await backend.get(
          `api/order/invoicesP/?${queryParams}`,
          getConfig()
        );
        if (response.status === 200) {
          return response.data;
        }
      } catch (error) {
        console.log(error);
      }
    };

export const getPrintableInvoices =
  (
    start,
    end,
    keyward,
    invoice_number,
    delivery_date,
    Payment_method,
    status,
    contact,
    location,
    account,
    pageno = 1,
    page_size = 100,
    location_name_in = ""
  ) =>
    async (dispatch) => {
      try {
        const response = await backend.get(
          `api/order/printable-invoices/?is_public=${store.getState().auth.Protected ? true : ""
          }&keyward=${keyward}&start=${start}&end=${end}&invoice_number=${invoice_number}&delivery_date=${delivery_date}&Payment_method=${Payment_method}&status=${status}&contact=${contact}&location=${location}&account=${account}&page=${pageno}&page_size=${page_size}&location_name_in=${location_name_in}`,
          getConfig()
        );
        if (response.status === 200) {
          return response.data;
        }
      } catch (error) {
        console.log(error);
      }
    };


export const getDispatchOrders =
  (
    start,
    end,
    keyward,
    invoice_number,
    delivery_date,
    Payment_method,
    status,
    contact,
    location,
    account,
    pageno = 1,
    page_size = 100,
    location_name_in = ""
  ) =>
    async (dispatch) => {
      try {
        const response = await backend.get(
          `api/order/dispatch-orders/?is_public=${store.getState().auth.Protected ? true : ""
          }&keyward=${keyward}&start=${start}&end=${end}&invoice_number=${invoice_number}&delivery_date=${delivery_date}&Payment_method=${Payment_method}&status=${status}&contact=${contact}&location=${location}&account=${account}&page=${pageno}&page_size=${page_size}&location_name_in=${location_name_in}`,
          getConfig()
        );
        if (response.status === 200) {
          return response.data;
        }
      } catch (error) {
        console.log(error);
      }
    };

export const getEcommerceSales =
  (
    start,
    end,
    keyward,
    invoice_number,
    delivery_date,
    Payment_method,
    status,
    contact,
    location,
    account,
    pageno = 1,
    page_size = 100
  ) =>
    async (dispatch) => {
      try {
        const response = await backend.get(
          `api/order/invoicesP/?is_public=${store.getState().auth.Protected ? true : ""
          }&keyward=${keyward}&start=${start}&end=${end}&invoice_number=${invoice_number}&delivery_date=${delivery_date}&Payment_method=${Payment_method}&status=${status}&contact=${contact}&location=${location}&account=${account}&page=${pageno}&page_size=${page_size}`,
          getConfig()
        );
        if (response.status === 200) {
          return response.data;
        }
      } catch (error) {
        console.log(error);
      }
    };
export const getVATReport =
  (
    start,
    end,
    invoice_number,
    delivery_date,
    Payment_method,
    status,
    contact,
    location,
    account,
    contains_item = "true"
  ) =>
    async (dispatch) => {
      try {
        const response = await backend.get(
          `api/order/vat/?is_public=${store.getState().auth.Protected ? true : ""
          }&start=${start}&end=${end}&invoice_number=${invoice_number}&delivery_date=${delivery_date}&Payment_method=${Payment_method}&status=${status}&contact=${contact}&location=${location}&account=${account}&contains_item=${contains_item}`,
          getConfig()
        );
        if (response.status === 200) {
          return response.data;
        }
      } catch (error) {
        console.log(error);
      }
    };

export const getSalesReportByOutLetMonth =
  (location, month, year) => async (dispatch) => {
    try {
      const response = await backend.get(
        `api/order/invoices/?is_public=${store.getState().auth.Protected ? true : ""
        }&month=${month}&year=${year}&location=${location}`,
        getConfig()
      );
      if (response.status === 200) {
        return response.data;
      }
    } catch (error) {
      console.log(error);
    }
  };

export const getSalesReportByInvoiceCount = (from, to) => async (dispatch) => {
  try {
    const response = await backend.get(
      `api/order/report/${from}/${to}`,
      getConfig()
    );
    if (response.status === 200) {
      return response.data;
    }
  } catch (error) {
    console.log(error);
  }
};

export const getDeliveryReport =
  (
    start,
    end,
    invoice_number,
    delivery_date,
    Payment_method,
    status,
    contact,
    location,
    account,
    DeliveryType = ""
  ) =>
    async (dispatch) => {
      try {
        const response = await backend.get(
          `api/order/delivery/?is_public=${store.getState().auth.Protected ? true : ""
          }&start=${start}&end=${end}&invoice_number=${invoice_number}&delivery_date=${delivery_date}&Payment_method=${Payment_method}&status=${status}&contact=${contact}&location=${location}&account=${account}&DeliveryType=${DeliveryType}`,
          getConfig()
        );
        if (response.status === 200) {
          return response.data;
        }
      } catch (error) {
        console.log(error);
      }
    };

export const getServiceReport =
  (start, end, keyward, employe__id = "", pageno = 1, page_size = 10) =>
    async (dispatch) => {
      try {
        const response = await backend.get(
          `api/order/ServicesP/?is_public=${store.getState().auth.Protected ? true : ""
          }&start=${start}&end=${end}&keyward=${keyward}&employe__id=${employe__id}&page=${pageno}&page_size=${page_size}`,
          getConfig()
        );
        if (response.status === 200) {
          return response.data;
        }
      } catch (error) {
        console.log(error);
      }
    };



export const getStockHistory = (title, attributes = '') => async () => {
  try {
    let url = `api/order/stockhistory/?title=${title}`;
    if (attributes) {
        url += `&attributes=${attributes}`;
    }
    const response = await backend.get(
      url,
      getConfig()
    );
    if (response.status === 200) {
      return response.data;
    }
  } catch (error) {
    console.log(error.response);
  }
};

export const getStockHistoryAll = () => async () => {
  try {
    const response = await backend.get(`api/order/stockhistoryall/`, getConfig());
    if (response.status === 200) {
      return response.data;
    }
  } catch (error) {
    console.log(error.response);
  }
};

export const getInvoicePaymentsReport =
  (
    start,
    end,
    keyward,
    invoice_id,
    location,
    month,
    year,
    account,
    is_public,
    pageno = 1,
    page_size = 100
  ) =>
    async (dispatch) => {
      try {
        const response = await backend.get(
          `api/order/invoicepayments-report/?invoice__is_public=${is_public !== undefined ? is_public : ""
          }&keyward=${keyward}&start=${start}&end=${end}&invoice__id=${invoice_id}&invoice__location__id=${location}&month=${month}&year=${year}&account=${account}&page=${pageno}&page_size=${page_size}`,
          getConfig()
        );
        if (response.status === 200) {
          return response.data;
        }
      } catch (error) {
        console.log(error);
      }
    };

export const getMonthlySalesReport = async (year, month, location = null) => {
  try {
    let url = `api/order/dailysalesreport/monthly-sales/?year=${year}&month=${month}`;

    if (location) {
      url += `&location=${location}`;
    }

    const response = await backend.get(url, getConfig());
    if (response.status === 200) {
      return response.data;
    }
  } catch (error) {
    console.error('Error fetching monthly sales report:', error);
    const errorMessage = error.response && error.response.data && error.response.data.error
      ? error.response.data.error
      : 'Failed to fetch sales report';
    throw new Error(errorMessage);
  }
};

// Get top selling products for each locations
export const getTopProductsByLocation = async (year, month) => {
  try {
    const url = `api/order/top-selling-products/single_location/?year=${year}&month=${month}`;
    const response = await backend.get(url, getConfig());

    if (response.status === 200) {
      return response.data;
    }
  } catch (error) {
    console.error('Error fetching top products by location:', error);
    const errorMessage = error.response.data.error
      ? error.response.data.error
      : 'Failed to fetch top selling products by location';
    throw new Error(errorMessage);
  }
};

// Get top selling products across all locations
export const getTopProductsAllLocations = async (year, month) => {
  try {
    const url = `api/order/top-selling-products/all-location/?year=${year}&month=${month}`;
    const response = await backend.get(url, getConfig());

    if (response.status === 200) {
      return response.data;
    }
  } catch (error) {
    console.error('Error fetching top products for all locations:', error);
    const errorMessage = error.response.data.error
      ? error.response.data.error
      : 'Failed to fetch top selling products for all locations';
    throw new Error(errorMessage);
  }
};

export const getTodaysMethodRegistered = (location) => async (dispatch) => {

  try {
    const response = await backend.get(
      `api/order/todays-method-registered/?location=${location || ""}`,
      getConfig()
    );
    if (response.status === 200) {
      return response.data;
    }
  } catch (error) {
    console.log(error);
  }
};
export const getDispatchReport =
  (start = "", end = "", location = "", pageno = 1, page_size = 100, DeliveryType = "") =>
    async (dispatch) => {
      try {
        const response = await backend.get(
          `api/order/dispatched-report/?start=${start}&end=${end}&location=${location}&page=${pageno}&page_size=${page_size}&DeliveryType=${DeliveryType}`,
          getConfig()
        );
        if (response.status === 200) {
          return response.data;
        }
      } catch (error) {
        console.log(error);
      }
    };
